import { useState, useCallback, useRef } from 'react';
import { PdfManager } from '../../document/services/PdfManager.js'; // Verify this path
export function usePdfDocumentContent() {
    const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const currentLoadingIdentityKeyRef = useRef(null);
    const pdfManager = PdfManager.getInstance();
    const loadPdfContent = useCallback(async (identity) => {
        const newIdentityKey = identity ? `${identity.type}-${identity.id}` : null;
        if (!identity) {
            setPdfArrayBuffer(null);
            setIsLoading(false);
            setError(null);
            currentLoadingIdentityKeyRef.current = null;
            return;
        }
        if (identity.type !== 'pdf') {
            console.error('[usePdfDocumentContent] Invalid document type. Expected PDF. Received:', identity.type);
            setError(new Error('Invalid document type for usePdfDocumentContent. Expected PDF.'));
            setPdfArrayBuffer(null);
            setIsLoading(false);
            currentLoadingIdentityKeyRef.current = null;
            return;
        }
        if (isLoading && currentLoadingIdentityKeyRef.current === newIdentityKey) {
            return;
        }
        setIsLoading(true);
        setError(null);
        currentLoadingIdentityKeyRef.current = newIdentityKey;
        // Optionally clear previous buffer to prevent showing stale data,
        // though this might cause a flicker if the same content is re-requested quickly.
        // setPdfArrayBuffer(null);
        try {
            const result = (await pdfManager.loadDocument(identity));
            if (currentLoadingIdentityKeyRef.current === `${result.identity.type}-${result.identity.id}`) {
                if (result && result.pdfContent) {
                    setPdfArrayBuffer(result.pdfContent);
                }
                else {
                    console.warn('[usePdfDocumentContent] Loaded PDF document, but no pdfContent found for identity:', identity.id);
                    setPdfArrayBuffer(null);
                    // setError(new Error('PDF content not found after loading.')); // Optional
                }
            }
            else {
                /* empty */
            }
        }
        catch (e) {
            if (currentLoadingIdentityKeyRef.current === newIdentityKey) {
                console.error('[usePdfDocumentContent] Error loading PDF content (ref check) for identity:', identity.id, e);
                setError(e instanceof Error ? e : new Error('Unknown error loading PDF content.'));
                setPdfArrayBuffer(null);
            }
            else {
                /* empty */
            }
        }
        finally {
            if (currentLoadingIdentityKeyRef.current === newIdentityKey) {
                setIsLoading(false);
                currentLoadingIdentityKeyRef.current = null;
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pdfManager]);
    return { pdfArrayBuffer, isLoading, error, loadPdfContent };
}
//# sourceMappingURL=usePdfDocumentContent.js.map